import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { Controller, useFormContext } from "react-hook-form";
import clsx from "clsx";
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import Divider from "../../../../components/divider";
import { serviceOptions } from "../../../../constants";

export default function OrderDetails() {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <section>
      <div className="flex flex-col gap-2 mb-7">
        <h2 className="text-2xl font-medium text-gray-950">Order Details</h2>
        <p className="text-sm font-normal text-gray-400">
          Please provide your order and shipping information
        </p>
      </div>

      <div className="grid grid-cols-1 gap-7 sm:grid-cols-2">
        <div className="flex flex-col gap-2">
          <label
            htmlFor="eBayOrderId"
            className="block text-sm/6 font-normal text-gray-950"
          >
            eBay Order ID
          </label>
          <div>
            <input
              id="eBayOrderId"
              type="text"
              autoComplete="off"
              placeholder="Enter your order ID"
              {...register("eBayOrderId", {
                required: "Order ID is required",
                pattern: {
                  value: /^\d{2}-\d{5}-\d{5}$/,
                  message: "eBayOrderId must be in XX-XXXXX-XXXXX format",
                },
              })}
              disabled
              className={clsx(
                "block w-full rounded-xl border px-4 py-3.5 text-sm outline-none",
                "focus:ring-2 focus:ring-blue-500 placeholder:text-gray-500",
                errors.eBayOrderId
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-200",
              )}
            />
            {errors.eBayOrderId && (
              <p className="mt-2 text-sm text-red-500">
                {errors.eBayOrderId.message as string}
              </p>
            )}
          </div>
        </div>
        <input
          type="hidden"
          {...register("orderLineItems.0.orderLineItemId")}
        />

        <Controller
          name="orderLineItems.0.serviceType"
          control={control}
          rules={{ required: "Service is required" }}
          render={({ field, fieldState }) => (
            <div className="flex flex-col gap-2">
              <label className="block text-sm/6 font-normal text-gray-950">
                Service type
              </label>

              <Listbox
                value={
                  serviceOptions.find((o) => o.value === field.value) ?? null
                }
                onChange={(opt) => field.onChange(opt?.value ?? null)}
              >
                <ListboxButton
                  className={clsx(
                    "flex w-full items-center justify-between rounded-xl border px-4 py-3.5 text-sm outline-none",
                    "focus:ring-2 focus:ring-blue-500",
                    fieldState.error
                      ? "border-red-500 focus:ring-red-500"
                      : "border-gray-200",
                  )}
                >
                  <span className="truncate">
                    {serviceOptions.find((o) => o.value === field.value)
                      ?.label ?? (
                      <span className="text-gray-500">Select service type</span>
                    )}
                  </span>

                  <ChevronDownIcon className="h-5 w-5 text-gray-500" />
                </ListboxButton>

                <ListboxOptions
                  anchor="bottom"
                  className="mt-1 w-(--button-width) rounded-xl border border-gray-200 bg-white p-1 shadow outline-none"
                >
                  {serviceOptions.map((opt) => (
                    <ListboxOption
                      key={opt.value}
                      value={opt}
                      className="cursor-pointer rounded-lg px-3 py-2 text-sm data-focus:bg-blue-50 data-focus:text-blue-500"
                    >
                      {opt.label}
                    </ListboxOption>
                  ))}
                </ListboxOptions>
              </Listbox>

              {fieldState.error && (
                <p className="text-sm text-red-600">
                  {fieldState.error.message}
                </p>
              )}
            </div>
          )}
        />
      </div>

      <Divider />
    </section>
  );
}
